import { render, staticRenderFns } from "./PrintCashierCutDetails.vue?vue&type=template&id=b5cf7d64&scoped=true"
import script from "./PrintCashierCutDetails.vue?vue&type=script&lang=js"
export * from "./PrintCashierCutDetails.vue?vue&type=script&lang=js"
import style0 from "./PrintCashierCutDetails.vue?vue&type=style&index=0&id=b5cf7d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cf7d64",
  null
  
)

export default component.exports